<h1 mat-dialog-title [ngClass]="{'darkMode': darkModeService.darkMode,'lightMode': !darkModeService.darkMode}" *ngIf="data.title">{{data.title}}</h1>
<div mat-dialog-content [ngClass]="{'darkMode': darkModeService.darkMode,'lightMode': !darkModeService.darkMode}">
  <p *ngIf="data.message" [innerHTML]="data.message"></p>
  <p *ngIf="!data.title">
    <mat-progress-spinner diameter="50" mode="indeterminate" color="primary" strokeWidth="5"
      value="100">
    </mat-progress-spinner>
  <!-- <h4>Organizations</h4>
  <mat-form-field appearance="fill">
    <mat-label>Organization</mat-label>
    <mat-select [(value)]="selected">
      <mat-option *ngFor="let organization of data.infrastructure.organizations" [value]="organization">
        {{organization.name}}
      </mat-option>
    </mat-select>
  </mat-form-field> -->
  <form class="input-form" [formGroup]="organizationForm">
    <mat-form-field class="input-full-width">
      <mat-label>Organization</mat-label>
      <input 
        matInput 
        placeholder="Ex. uslab" 
        formControlName="orgDelete"
      >
    </mat-form-field>
  </form>
</div>

<div [ngClass]="{'darkMode': darkModeService.darkMode,'lightMode': !darkModeService.darkMode}" mat-dialog-actions  *ngIf="data.title">
  <button mat-button *ngIf="data.cancel" (click)="onNoClick(); data.cancel()">Cancel</button>
  <button mat-button [disabled]="!organizationForm.valid" (click)="onNoClick(); data.ok(organizationForm.controls.orgDelete.value);" cdkFocusInitial>Ok</button>
</div>
